const CONTACT_TOKEN_PATTERN = /^[a-zA-Z0-9]{8,9}$/
const REPEATED_CHARACTER_PATTERN = /^([a-zA-Z0-9])\1{7,8}$/

export const RESERVED_APP_PATH_SEGMENTS = new Set(['expired', 'error', 'dev', 'assets'])

function hasOnlyRepeatedCharacters(segment: string): boolean {
  return REPEATED_CHARACTER_PATTERN.test(segment)
}

export function isContactTokenFormat(segment: string): boolean {
  const trimmed = segment.trim()
  if (!CONTACT_TOKEN_PATTERN.test(trimmed)) return false
  if (hasOnlyRepeatedCharacters(trimmed)) return false
  return true
}

export function isReservedAppPathSegment(segment: string): boolean {
  return RESERVED_APP_PATH_SEGMENTS.has(segment.trim())
}
